export default "__VITE_ASSET__pnpg62d___"